import UserPage from "./UserPage";
export * from "./types";

export default UserPage;
